import {Sprite} from 'pixi.js';
import {consoleLogger, CoreDI, DeviceType, inject} from '@gongxigames/framework/core';
import {LAYERS} from '@gongxigames/framework/slot/configs/Layers';
import {View} from '@gongxigames/framework/slot/fragments/module/view';
import {GameConfig} from '@gongxigames/framework/slot';

export class KeypadView extends View {
    public static readonly NAME: symbol = Symbol('KeypadView');
    public static layer = LAYERS.KEYPAD;
    public static platform: DeviceType = DeviceType.DESKTOP;

    @inject(CoreDI.GameConfig)
    protected _gameConfig!: GameConfig;

    protected _mainSprite!: Sprite;

    public init(): void {
        super.init();

        this.initMainSprite();
    }

    protected initMainSprite(): void {
        const rootName = 'bottomBar';
        const config = this._objectBuilder.getDisplayObjectConfigByName(this.getMainSpriteName(rootName));

        if (config) {
            this._mainSprite = this._objectBuilder.buildSprite(config);
            this.container.addChild(this._mainSprite);
        } else {
            consoleLogger.warn(`No Sprite - '${rootName}'. Please, check resources!`);
        }
    }

    protected getMainSpriteName(rootName: string): string {
        return this.isRubyCoinsGame ? 'buyBonus_' + rootName : rootName;
    }

    public get mainSprite(): Sprite {
        return this._mainSprite;
    }

    public get isRubyCoinsGame(): boolean {
        return this._gameConfig.isRubyCoinsGame!;
    }
}
